export const BODY = Symbol('Body internals');
export const RESPONSE = Symbol('Response internals');
